import React, { Component, PropTypes } from 'react';
import '../styles/learnMore.scss';
import RecommendationAlgorithm from '../models/RecommendationAlgorithm'
import CitationComponent from './CitationComponent'
import Recommendation from '../models/Recommendation'
import Answer from '../models/Answer'
import NumPad from './NumPad'
import EmailHelper from '../utils/emailHelper'
import * as resourceConstants from '../constants/ResourceConstants'
import * as constants from '../constants/constants'
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');


class LearnMoreComponent extends Component {
  constructor() {
    super();
  }

  onAlgorithmFlowChartButtonClick(event) {
    window.open(resourceConstants.algorithmURL, '_blank', 'fullscreen=yes');
  }

  onPaperButtonClick(event) {
    this.props.navigation.showTextContent(constants.kPapersText);
  }

  onBackgroundButtonClick(event) {
    this.props.navigation.showTextContent(RecommendationAlgorithm.appBackgroundText());
  }

  onDisclaimerButtonClick(event) {
    this.props.navigation.showTextContent(RecommendationAlgorithm.shortDisclaimer());
  }

  onFeedBackButtonClick(event) {
    EmailHelper.openEmailClient("Aspirin Guide Feedback", "", resourceConstants.kSupportEmail);
  }

  render() {
    return (
      <div className={"root"}>
      <div className="learnMoreRoot">
        {this.props.navigation.navBar()}
        <img src={require("../images/aspiringuide-logo.png")} className="learnMoreAspirinLogo" />
        <div className="learnMoreButton" onClick={this.onBackgroundButtonClick.bind(this)}>
        Background
          </div>
        <div className="learnMoreButton" onClick={this.onAlgorithmFlowChartButtonClick.bind(this)}>
          Algorithm Flow Chart
        </div>
        <div className="learnMoreButton" onClick={this.onPaperButtonClick.bind(this)}>
          Papers about the App/Algorithm
          </div>
        <div className="learnMoreButton" onClick={this.onFeedBackButtonClick.bind(this)}>
          Feedback
        </div>
        <div className="learnMoreButton" onClick={this.onDisclaimerButtonClick.bind(this)}>
          Disclaimer
        </div>
      </div>
        </div>

    );
  }

}

export default LearnMoreComponent;



/** WEBPACK FOOTER **
 ** ./src/components/LearnMoreComponent.js
 **/